import React from 'react';
import PropTypes from 'prop-types';
import RenderAutoCompleteInputField from 'components/form/InputFields/RenderAutoCompleteInputField';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import RenderLocalisationInputField from 'components/form/InputFields/RenderLocalisationInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import pointsOfInterestHelper from 'helpers/pointsOfInterest';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, Field, isInvalid } from 'redux-form';

class PointsOfInterestCreateForm extends React.Component {
    constructor(props) {
        super(props);

        const {
            translate,
            initialize,
        } = props;

        // Translate all Point of Interest names.
        const poiChoices = utils.map(pointsOfInterestHelper.getLabeledTypes(), (item) => {
            item.name = translate(item.name);

            return item;
        });

        this.state = {
            poiChoices: poiChoices,
        };

        initialize({
            is_highlighted: false,
        });
    }

    render() {
        const {
            form,
            handleSubmit,
            handleSubmitForm,
            invalid,
            localisationFields,
            pristine,
            submitting,
            translate,
        } = this.props;

        const {
            poiChoices,
        } = this.state;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.points_of_interest.fields.address') }
                                    name='address'
                                    type='text'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    choices={ poiChoices }
                                    component={ RenderAutoCompleteInputField }
                                    label={ translate('resources.points_of_interest.fields.type') }
                                    name='type'
                                    optionText='name'
                                    optionValue='id'
                                    resource='users'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderBooleanInputField }
                                    label={ translate('resources.points_of_interest.fields.is_highlighted') }
                                    name='is_highlighted'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <RenderLocalisationInputField
                                    fields={ localisationFields }
                                    form={ form }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

PointsOfInterestCreateForm.defaultProps = {
    localisationFields: [
        {
            maxLength: 255,
            name: 'name',
            required: true,
            type: 'text',
        },
        {
            maxLength: 10000,
            name: 'description',
            required: true,
            type: 'textarea',
        },
    ],
};

PointsOfInterestCreateForm.propTypes = {
    form: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    localisationFields: PropTypes.array,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.address) {
                errors.address = translate('forms.required');
            }

            if (!values.type) {
                errors.type = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(PointsOfInterestCreateForm);



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/create/PointsOfInterestCreateForm.js